/**
 * `/api/auth` wrapper — nonce minting.
 *
 * One call, used by every value-moving flow (claims, schedules, draw claims,
 * lease creation) before it asks the wallet to sign.
 */
import type { GetJwtNonceRequest, GetJwtNonceResponse } from "@swarm/shared/schemas";
import { getJwtNonceResponseSchema } from "@swarm/shared/schemas";

import { routes } from "@/hooks/useRoutes/useRoutes";

import { apiRequest } from "./client";

/**
 * Mints a short-lived nonce bound to `owner`.
 *
 * The returned `nonceToken` is a stateless JWT: it stays replayable until the
 * endpoint that acts on it calls `consumeNonce`, so do not cache it across
 * flows — request a fresh one per signature.
 */
export const getJwtNonce = (body: GetJwtNonceRequest): Promise<GetJwtNonceResponse> =>
  apiRequest(routes.api.auth.getJWTNonce(), getJwtNonceResponseSchema, {
    method: "POST",
    body,
  });
